module.exports = __webpack_public_path__ + "img/upload-file.7e5914b9.svg";